import axios from 'axios';
import { useContext, useEffect } from 'react';
import { func } from 'prop-types';
import Header from '../../../shared/Header';
import Placeholder from '../../../shared/Placeholder';
import Stack from '../../../shared/layouts/Stack';
import Notification from '../components/Notification';
import { useQuery } from 'react-query';
import MessagebarContext from '../../../../context/MessagebarContext';
import { useTranslation } from 'react-i18next';
import WhiteLabelContext from "../../../../context/WhiteLabelContext";

const NotificationsWidget = ({ setIsLoading, hideTitle = false }) => {
  const { setAlertMessage } = useContext(MessagebarContext);
  const { isArgo } = useContext(WhiteLabelContext);
  const { t } = useTranslation();

  const { isLoading, data: notifications = [] } = useQuery(
    'notifications',
    async () =>
      await axios
        .get(`/user/notifications/new?exclude_request_notifications=${isArgo}`)
        .then(({ data = [] }) => {
          const filteredNotification = data.reduce((total, current) => {
            if (current.type === 'dossier_updated') {
              const alreadyExists = total.find(
                notification => notification.type === current.type
              );
              if (alreadyExists) return total;
            }
            total.push(current);
            return total;
          }, []);

          window.scrollTo(0, 0);
          return filteredNotification;
        })
        .catch(() => setAlertMessage())
  );

  useEffect(() => {
    if (!isLoading) setIsLoading(false);
  }, [isLoading, setIsLoading]);

  const isEmpty = notifications.length === 0;

  if (isLoading) return null;
  return (
    <Stack space="2xl" bg="white">
      {!hideTitle && (
        <Header
          title={
            isEmpty
              ? t('Je bent up-to-date')
              : t('Bekijk hier je laatste updates en rond je to-do’s af')
          }
          variant="page"
        />
      )}
      {isEmpty ? (
        <Placeholder>{t('Je hebt geen to-do’s')}</Placeholder>
      ) : (
        <Stack space="m">
          {notifications.map(({ ...notification }, i) => (
            <Notification key={i} {...notification} />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

NotificationsWidget.propTypes = {
  setIsLoading: func
};

NotificationsWidget.defaultProps = {
  setIsLoading: () => {}
};

export default NotificationsWidget;
